export default __webpack_public_path__ + "static/media/default.53ff0bf1d79c19a99aabd399f9006b98.png";